import { merge } from "@awe-web/shared/lib";
import { toIsoString, dateStringToDateTime } from "@awe-web/shared/lib";
import { loadFormConfiguration, serverValidationFailed, loadCreditCards } from "@awe-web/shared/lib";
import { extendSignUp } from "../../../user/actions.js";
import { B2C_SignUpExtended } from "../../../routing/routes.js";
import { newMapFormValues } from "@awe-web/shared/lib";

export const initialize = () => async (dispatch) => {
  await Promise.all([
    dispatch(loadFormConfiguration("extendRegistration")),
    dispatch(loadCreditCards())
  ]);
};

const normalizeDate = value => toIsoString(dateStringToDateTime(value));

export const submit = (formValues, { setSubmitting, validateForm }) => async (dispatch, getState, context) => {
  const mapFormValues = newMapFormValues("extendRegistration")(getState());
  const { rentContractId, ...values } = formValues;
  const normalizedValues = mapFormValues(merge(values, {
    "Driver:identCardIssued": normalizeDate(formValues["Driver:identCardIssued"]),
    "Driver:identcardValidTill": normalizeDate(formValues["Driver:identcardValidTill"]),
    "Driver:licenceDateIssued": normalizeDate(formValues["Driver:licenceDateIssued"])
  }));

  try {
    setSubmitting(true);
    await dispatch(extendSignUp(normalizedValues));
    return B2C_SignUpExtended.path();
  }
  catch (error) {
    if (error.type === "VALIDATION_FAILED") {
      const groupName = "extendRegistration";
      const errors = error.errors;
      dispatch(serverValidationFailed(groupName, values, errors));
      setTimeout(() => {
        validateForm();
      }, 200);
      return;
    }

    throw error;
  }
  finally {
    setSubmitting(false);
  }
};
